import React from "react";
import Layout from "../../components/Layout";

const Overview = () => {
  return <Layout>content</Layout>;
};

export default Overview;
